<div class="container">
  <div class="pt-10">
    <ion-row class="pt-10">
      <ion-col size="5" size-md="5" size-lg="5" size-xs="12">
        <div class="sidebar-content">
          <ion-grid>
            <ion-row>
           
    
              <ion-col size="6">
                <label for="year" class="filter-label">Select Year:</label>
                <ng-select class="filter-dropdown" [items]="years" bindLabel="year" bindValue="year"
                  [(ngModel)]="selectedYear" placeholder="Select Year">
                </ng-select>
              </ion-col>
              <ion-col size="6">
                <label for="month" class="filter-label">Select Month:</label>
                <ng-select class="filter-dropdown" [items]="months" bindLabel="name" bindValue="value"
                  [(ngModel)]="selectedMonth" placeholder="Select Month">
                </ng-select>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </ion-col>
    </ion-row>
    
    <ion-row>
      <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
        <ion-row>
          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card" 
            (click)="onClickCard('1')">
              <div class="d-flex">
                <div>
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
                </div>
                <ion-row>
                  <ion-col size="12">
                    <div class="text-center ml-30">
                      <p class="fs-12 font_semibold text-center">Nominations</p>
                      <p class="mt-5 fs-12 font_bold Cerulean-Blue cp" >250</p>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div>
          </ion-col>
    
    
          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card" (click)="onClickCard('2')" >
              <div class="d-flex">
                <div>
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
                </div>
                <ion-row>
                  <ion-col size="12">
                    <div class="text-center ml-30">
                      <p class="fs-12 font_semibold text-center">Attended</p>
                      <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">200</p>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div>
          </ion-col>
    
          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card"  (click)="onClickCard('3')">
              <div class="d-flex">
                <div>
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
                </div>
                <ion-row>
                  <ion-col size="12">
                    <div class="text-center ml-30">
                      <p class="fs-12 font_semibold text-center">Upcoming Programs</p>
                      <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">6</p>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div>
          </ion-col>
    
          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card" (click)="onClickCard('4')">
              <div class="d-flex">
                <div>
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
                </div>
                <ion-row>
                  <ion-col size="12">
                    <div class="text-center ml-30">
                      <p class="fs-12 font_semibold text-center">Total Mondays</p>
                      <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">10000</p>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div>
          </ion-col>
          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card" (click)="onClickCard('5')">
              <div class="d-flex">
                <div>
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
                </div>
                <ion-row>
                  <ion-col size="12">
                    <div class="text-center ml-30">
                      <p class="fs-12 font_semibold text-center">Recommended Programs</p>
                      <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">5</p>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
    
    
    </ion-row>
    
    <!-- Graph code -->
    
    <ion-row class="pt-10">
      <ion-col size="12">
        <div class="graphs card m-50">
          <!-- Header -->
          <ion-row class="justify-content-between align-items-center">
            <ion-col size="8">
              <div class="fs-16 font_bold orange-text">L&D Programme Performance</div>
            </ion-col>
            <ion-col size="4" class="text-right">
              <div class="d-flex graph-icon">
                <span (click)="switchGraphType('bar')">
                  <img *ngIf="graphType !== 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="">
                  <img *ngIf="graphType === 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
                </span>
                <span (click)="switchGraphType('line')">
                  <img *ngIf="graphType !== 'line'" src="./assets/icon/lineChartIcon.svg" alt="">
                  <img *ngIf="graphType === 'line'" src="./assets/icon/activeLineChart.svg" alt="">
                </span>
                <span class="cp" (click)="downloadGraph()">
                  <img src="./assets/icon/downloadIcon.svg" alt="">
                </span>
              </div>
            </ion-col>
          </ion-row>
    
          <!-- Filters -->
          <ion-row class="pt-10">
            <ion-col size="4">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Select Fiscal Year</mat-label>
                <mat-select [(ngModel)]="selectedYear">
                  <mat-option *ngFor="let year of fiscalYears" [value]="year">{{ year }}</mat-option>
                </mat-select>
              </mat-form-field>
            </ion-col>
            <ion-col size="4">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Select Programme</mat-label>
                <mat-select [(ngModel)]="selectedProgramme">
                  <mat-option *ngFor="let program of programs" [value]="program">{{ program }}</mat-option>
                </mat-select>
              </mat-form-field>
            </ion-col>
          </ion-row>
    
          <!-- Graph -->
          <div id="LndPerformanceGraph" style="width: 100%; height: 400px;"></div>
    
          <!-- Legend -->
          <ion-row class="align-items-center pt-10">
            <ion-col size="6" class="d-flex align-items-center">
              <div class="legend-box orange"></div>
              <span class="fs-14 font_regular ml-5">Employee Score</span>
            </ion-col>
            <ion-col size="6" class="d-flex align-items-center">
              <div class="legend-box blue"></div>
              <span class="fs-14 font_regular ml-5">Manager Score</span>
            </ion-col>
          </ion-row>
        </div>
      </ion-col>
    </ion-row>
    
    <ion-row class="pt-10">
        <ion-col size="12">
          <div class="graphs card m-50">
            <ion-row class="justify-content-between">
              <ion-col size-sm="12" size-md="10" size-lg="10" size-xs="12" class="">
                <div class="fs-16 font_bold">Monthly attrition rate </div>
              </ion-col>
              <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12" class="">
                <div class="d-flex graph-icon">
                  <span (click)="switchGraphType('bar')">
                    <img *ngIf="graphType != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="">
                    <img *ngIf="graphType == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
                  </span>
    
                  <span (click)="switchGraphType('line')">
                    <img *ngIf="graphType != 'line'" src="./assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="graphType == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
                  </span>
    
                  <span class="cp" (click)="downloadGraph()">
                    <img src="./assets/icon/downloadIcon.svg" alt="">
                  </span>
                </div>
              </ion-col>
            </ion-row>
            <ion-row class="pt-10">
              <ion-col size="5" size-md="5" size-lg="5" size-xs="12">
                <div class="sidebar-content">
                  <ion-grid>
                    <ion-row>
                      <ion-col size="6">
                        <label for="month" class="filter-label">Select Month:</label>
                        <ng-select class="filter-dropdown" [items]="months" bindLabel="name" bindValue="value"
                          [(ngModel)]="selectedMonth" placeholder="Select Month">
                        </ng-select>
                      </ion-col>
    
                      <ion-col size="6">
                        <label for="year" class="filter-label">Select Year:</label>
                        <ng-select class="filter-dropdown" [items]="years" bindLabel="year" bindValue="year"
                          [(ngModel)]="selectedYear" placeholder="Select Year">
                        </ng-select>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </div>
              </ion-col>
            </ion-row>
            <div id="AgeGenderGraph" style="width: 100%; height: 400px;"></div>
    
          </div>
        </ion-col>
    </ion-row>
    
    <ion-row class="pt-10">
    
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs card m-50">
            <ion-row class="justify-content-center">
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <div class="fs-16 font_bold">Dept. Wise</div>
              </ion-col>
              <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                <div class="d-flex graph-icon">
                  <span>
                    <img src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
                  </span>
                  <span>
                    <img src="./assets/icon/TableIconActive.svg" alt="">
                  </span>
                </div>
              </ion-col>
            </ion-row>
    
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xl="12">
    
              <div id="bar-line-chart" style="width: 100%; height: 400px;"></div>
            </ion-col>
          </div>
        </ion-col>
    
    
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs card m-50">
            <ion-row class="justify-content-center">
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <div class="fs-16 font_bold">Band Wise</div>
              </ion-col>
              <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                <div class="d-flex graph-icon">
                  <span>
                    <img src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
                  </span>
                  <span>
                    <img src="./assets/icon/TableIconActive.svg" alt="">
                  </span>
                </div>
              </ion-col>
            </ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div id="bar-line-approvedByFinance-chart" style="width: 100%; height: 400px;"></div>
            </ion-col>
          </div>
        </ion-col>
    
    </ion-row>
    
    
    
    <ion-row class="pt-10">
    
      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
        <div class="graphs card m-50">
          <ion-row class="justify-content-center">
            <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
              <div class="fs-16 font_bold">Grade Wise</div>
            </ion-col>
            <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
              <div class="d-flex graph-icon">
                <span>
                  <img src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
                </span>
                <span>
                  <img src="./assets/icon/TableIconActive.svg" alt="">
                </span>
              </div>
            </ion-col>
          </ion-row>
    
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xl="12">
            <div id="bar-line-chart" style="width: 100%; height: 400px;"></div>
          </ion-col>
        </div>
      </ion-col>
    
    
      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
        <div class="graphs card m-50">
          <ion-row class="justify-content-center">
            <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
              <div class="fs-16 font_bold">State Wise</div>
            </ion-col>
            <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
              <div class="d-flex graph-icon">
                <span>
                  <img src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
                </span>
                <span>
                  <img src="./assets/icon/TableIconActive.svg" alt="">
                </span>
              </div>
            </ion-col>
          </ion-row>
    
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div id="bar-line-approvedByFinance-chart" style="width: 100%; height: 400px;"></div>
          </ion-col>
        </div>
      </ion-col>
    
    </ion-row>
    
    
    <ion-row class="pt-10">
      <ion-col size="12">
        <div class="graphs card m-50">
          <ion-row class="justify-content-between">
            <ion-col size-sm="12" size-md="10" size-lg="10" size-xs="12" class="">
              <div class="fs-16 font_bold">How are you feeling today</div>
            </ion-col>
            <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12" class="">
              <div class="d-flex graph-icon">
                <span (click)="switchGraphType('bar')">
                  <img *ngIf="graphType != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="">
                  <img *ngIf="graphType == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
                </span>
    
                <span (click)="switchGraphType('line')">
                  <img *ngIf="graphType != 'line'" src="./assets/icon/lineChartIcon.svg" alt="">
                  <img *ngIf="graphType == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
                </span>
    
                <span class="cp" (click)="downloadGraph()">
                  <img src="./assets/icon/downloadIcon.svg" alt="">
                </span>
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="pt-10">
            <ion-col size="5" size-md="5" size-lg="5" size-xs="12">
              <div class="sidebar-content">
                <ion-grid>
                  <ion-row>
                    <ion-col size="6">
                      <label for="month" class="filter-label">Select Month:</label>
                      <ng-select class="filter-dropdown" [items]="months" bindLabel="name" bindValue="value"
                        [(ngModel)]="selectedMonth" placeholder="Select Month">
                      </ng-select>
                    </ion-col>
    
                    <ion-col size="6">
                      <label for="year" class="filter-label">Select Year:</label>
                      <ng-select class="filter-dropdown" [items]="years" bindLabel="year" bindValue="year"
                        [(ngModel)]="selectedYear" placeholder="Select Year">
                      </ng-select>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </ion-col>
          </ion-row>
          <div id="AgeGenderGraph" style="width: 100%; height: 400px;"></div>
    
        </div>
      </ion-col>
    </ion-row>
    
    
    
  </div>
</div>



